import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// Environment variables take precedence, but defaults are provided for convenience
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyBvXfgTk1RlVCYED-_BhOWt0nmfcqcydkI",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "arcade-91363.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "arcade-91363",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "arcade-91363.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "343373739951",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:343373739951:web:f4b4e8ca4be2a02130215a",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-Y60QXDJCNL",
};

// Check if Firebase is configured
const isFirebaseConfigured =
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId;

let app = null;
let db = null;
let auth = null;
let storage = null;

if (isFirebaseConfigured) {
  try {
    // Initialize Firebase
    app = initializeApp(firebaseConfig);

    // Initialize Firebase services
    db = getFirestore(app);
    auth = getAuth(app);
    storage = getStorage(app);
  } catch (error) {
    console.warn("Firebase initialization error:", error);
    console.warn("App will use localStorage fallback for data persistence");
  }
} else {
  console.warn("Firebase not configured. Please set up environment variables.");
  console.warn("App will use localStorage fallback for data persistence.");
  console.warn("See FIREBASE_SETUP.md for instructions.");
}

export { db, auth, storage };
export default app;
